// extracted by mini-css-extract-plugin
module.exports = {"DeliveryInput":"OffSiteDeliveryItemInput_DeliveryInput__1E49T"};